module.exports = __webpack_public_path__ + "img/ic-upload.bc13e334.png";